module.exports = __webpack_public_path__ + "img/20190717162919QQ截图20190717014849.baeac223.png";